<div class="flight_airlinelist_template">
  <div class="airlinelist_template">
    <div class="dialog_header d-flex justify-content-between align-items-center">
      <h3>Airlines List</h3>
      <span class="space"></span>
      <button mat-icon-button color="primary" (click)="closeDialog()"><mat-icon>close</mat-icon></button>
    </div>
    <div class="dialoag_body_">
      <div class="wrapper">
        <ng-container *ngFor="let item of list; let i = index">
          <div class="innerWrapper">
            <mat-checkbox color="primary" [(ngModel)]="item.isSelected" (change)="updateSelectedAirlines(item, $event.checked)">
              <!-- <img [src]="getAirlineCode(item.name) | imageUrl" [alt]="item.name"> -->
              {{item.name}}
            </mat-checkbox>
          </div>
        </ng-container>
      </div>
      <div class="dialog_footer mt-2">
        <button mat-button class="applyButton__"  (click)="onClickAdd()">Apply Selected List</button>
      </div>
    </div>
  </div>
</div>
